<template>
  <div>
    <table class="events wp-list-table widefat fixed striped">
      <thead>
        <tr>
          <td class="move"></td>
          <td class="event-id">Event ID</td>
          <td class="event-name">Event Name</td>
          <td class="event-url">Full Leaderboard Url</td>
          <td class="event-action"></td>
        </tr>
      </thead>
      <tbody ref="events">
        <tr v-for="(event, index) in events" :key="index">
          <td>
            <span class="dashicons dashicons-move ui-sortable-handle"></span>
            <input type="hidden" name="weight" v-model="event.weight"/>
          </td>
          <td><input type="text" v-model="event.id"/></td>
          <td><input type="text" v-model="event.name"/></td>
          <td><input type="text" v-model="event.url"/></td>
          <td><a href="#" @click="removeEvent($event, event)">Remove</a></td>
        </tr>
      </tbody>
    </table>
    <a href="#" @click="addEvent">Add more</a>
  </div>
</template>
<script>
export default {
  props: ['events'],
  methods: {
    addEvent(e){
      e.preventDefault();
      let newEvent = {id:'', name:'', url:'',weight: 0};
      this.events.forEach(element => {
        if(newEvent.weight <= element.weight){
          newEvent.weight = parseInt(element.weight) + 1;
        }
      });
      this.events.push(newEvent)
    },
    removeEvent(e, event){
      e.preventDefault();
      this.events.splice(this.events.indexOf(event),1);
    }
  },
  mounted () {
    jQuery(this.$refs.events).sortable({
      handler: '.dashicons-move',
      update (event, ui){
        ui.item.parent().find('tr').each((index, el)=>{
          jQuery(el).find('input[name=weight]').val(index).trigger('input');
          let e = document.createEvent('HTMLEvents');
          e.initEvent('input', true, true);
          jQuery(el).find('input[name=weight]')[0].dispatchEvent(e);
        })
      }
    })
  },
  watch:{
    events:{
      handler (val){
        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
table.events input{
  max-width: 100%;
  width: 100%;
}
table.events td.move{
  width: 10px;
}
table.events td.event-id{
  width: 100px;
}
table.events td.event-name{
  width: 150px;
}
table.events td.event-action{
  width: 80px;
}
.dashicons-move{
  cursor: move;
}
</style>